// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__1JNoc","content":"GlobalSearch_content__1ECbX"};